// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"Slider_ProseMirror__2kcEX","slider":"Slider_slider__3kVKd","slider__body":"Slider_slider__body__2Ohvx","slider__value":"Slider_slider__value__2KhOf"};